import { Switch } from '@mui/material';
import { withThemeNext } from '../../../../layout/theme-next';

export default withThemeNext(Switch);
